import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { ServiceService } from '../service.service';
import { ApiService } from '../core/api.service';
import { endPoints } from '../core/Apis/apiEndpoints';
import { CommonFunctionsService } from '../functions/common-functions.service';
import { Router, NavigationStart } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';


declare var bootstrap: any;

@Component({
  selector: 'app-employee-attendance-beta',
  templateUrl: './employee-attendance-beta.component.html',
  styleUrls: ['./employee-attendance-beta.component.css'],
})
export class EmployeeAttendanceBetaComponent implements OnInit, OnDestroy {
  @ViewChild('exportModal') exportModal!: ElementRef;

  attendanceList: any[] = [];
  employeeDropdown: any[] = [];
  departmentDropdown: any[] = [];
  departmentID: string = '';

  // Stats
  attendancePercentage: number = 0;
  absentPercentage: number = 0;
  fullDayCount: number = 0;
  absentCount: number = 0;
  halfDayCount: number = 0;
  halfDayPercentage: number = 0;
  groupedEmployee: any;
  filteredGroupedEmployee: any;

  // Display data
  displayGroupedEmployee: any;
  showOnlyAbsent: boolean = false;

  // Filters
  selectedDate = new Date();
  formattedDate = ''
  // fromDate = ''
  // toDate = ''

  isFactoryManager: boolean = false;
  isSupervisor: boolean = false;
  supervisor: any = {
    id: '',
    name: '',
  };
  filterForm: FormGroup;
  // dateRange = new FormGroup({
  //   start: new FormControl<Date | null>(null),
  //   end: new FormControl<Date | null>(null),
  // });
  exportForm: FormGroup;
  isLoading: boolean = false;
  isExporting: boolean = false;
  maxDate: string = '';

  // Modal management
  exportModalInstance: any;
  isModalOpen: boolean = false;

  // PERFORMANCE OPTIMIZATION PROPERTIES
  private filterDebounceTimer: any;
  private firstRecordCache = new Map();
  private routerSubscription: any;
  private nextUrl: string | null = null;

  // Pagination properties
  currentPage: number = 1;
  pageSize: number = 50;
  totalItems: number = 0;
  paginatedEmployees: any[] = [];
  // ADD THESE NEW PROPERTIES (after line 30)
  attendanceFilterOptions = [
    { value: 'absent', label: 'Absent', color: 'danger' },
    { value: 'local_leave', label: 'Local Leave', color: 'primary' },
    { value: 'vacation', label: 'Vacation', color: 'primary' },
    { value: 'sick_leave', label: 'Sick Leave', color: 'primary' },
  ];

  halfDayTypeOptions = [
    { value: 'all_half_day', label: 'All Half Days', color: 'warning' },
    { value: 'half_day_late_in', label: 'Half Day - Late In', color: 'warning' },
    { value: 'half_day_early_out', label: 'Half Day - Early Out', color: 'warning' },
    { value: 'half_day_general', label: 'Half Day (General)', color: 'warning' }
  ];

  selectedHalfDayType: string = 'all_half_day';
  halfDayLateInCount: number = 0;
  halfDayEarlyOutCount: number = 0;
  halfDayGeneralCount: number = 0;

  selectedFilter: string = 'absent';
  filteredCount: number = 0;
  filteredPercentage: number = 0;

  constructor(
    private apiService: ServiceService,
    private methodService: ApiService,
    private fb: FormBuilder,
    private commonfn: CommonFunctionsService,
    private route: Router,
    private http: HttpClient
  ) {
    this.filterForm = this.fb.group({
      date: [this.getTodayDate()],
      selectedEmployee: [''],
      selectedDepartment: [''],
    });

    this.exportForm = this.fb.group({
      fromDate: ['', Validators.required],
      toDate: ['', Validators.required]
    });

    // Set max date to today
    this.maxDate = this.getTodayDate();
  }

  // ========== PERFORMANCE OPTIMIZATION METHODS ==========

  // TrackBy functions for ngFor performance
  trackByEmployeeId(index: number, employee: any): string {
    return employee.employee_id || employee.employee_name || index.toString();
  }

  onDateChange(event: any): void {
    const selectedDate = event.target.value;
    if (selectedDate) {
      this.formattedDate = selectedDate;
      this.filterForm.controls['date'].setValue(selectedDate);  // ← ADD THIS LINE

      // Save to localStorage immediately when date changes
      const currentState = {
        ...this.filterForm.value,
        departmentID: this.departmentID,
        date: selectedDate,
        formattedDate: selectedDate,
        selectedFilter: this.selectedFilter,
        selectedHalfDayType: this.selectedHalfDayType
      };
      this.commonfn.saveFilterFormState(currentState);

      clearTimeout(this.filterDebounceTimer);
      this.filterDebounceTimer = setTimeout(() => {
        this.fetchReportData();
        this.clearFilter();
      }, 500);
    }
  }
  // ========== HELPER METHODS FOR STATUS CHECKING ==========
  private isPresentStatus(status: string): boolean {
    const normalizedStatus = (status || '').toLowerCase();
    return normalizedStatus === 'present' || normalizedStatus === 'working';
  }

  private isAbsentStatus(status: string): boolean {
    const normalizedStatus = (status || '').toLowerCase();
    return normalizedStatus === 'absent';
  }
  // private formatDate(date: Date): string {
  //   const year = date.getFullYear();
  //   const month = (date.getMonth() + 1).toString().padStart(2, '0');
  //   const day = date.getDate().toString().padStart(2, '0');
  //   return `${year}-${month}-${day}`;
  // }
  // onDateRangeApply(): void {
  //   const start = this.dateRange.value.start;
  //   const end = this.dateRange.value.end;

  //   if (start && end) {
  //     this.fromDate = this.formatDate(start);
  //     this.toDate = this.formatDate(end);
  //     this.formattedDate = this.fromDate;
  //     this.fetchReportData();
  //     this.clearFilter();
  //   }
  // }



  trackByAttendanceId(index: number, attendance: any): string {
    return attendance.attendance_id || attendance.date || index.toString();
  }

  private getAdminId(): string {
    return localStorage.getItem('admin_id') ||
      localStorage.getItem('userId') ||
      localStorage.getItem('user_id') ||
      localStorage.getItem('employee_id') ||
      localStorage.getItem('id') ||
      'unknown-admin';
  }

  // Debounced filter methods
  // onDateRangeChange(): void {
  //   const from = this.filterForm.controls['fromDate'].value;
  //   const to = this.filterForm.controls['toDate'].value;

  //   if (from && to) {
  //     this.fromDate = from;
  //     this.toDate = to;
  //     this.formattedDate = from;

  //     clearTimeout(this.filterDebounceTimer);
  //     this.filterDebounceTimer = setTimeout(() => {
  //       this.fetchReportData();
  //       this.clearFilter();
  //     }, 500);
  //   }
  // }

  onEmployeeChange(event: any): void {
    clearTimeout(this.filterDebounceTimer);
    this.filterDebounceTimer = setTimeout(() => {
      this.fetchReportData();
      this.clearFilter();
    }, 300);
  }

  onDepartmentChange(event: any): void {
    console.log('DEPARTMENT EVENT:', event);
    console.log('DEPARTMENT ID:', event?.department_id);
    console.log('DEPARTMENT NAME:', event?.department_name);
    clearTimeout(this.filterDebounceTimer);

    // Keep department id stable for the next fetch
    const deptId = event?.department_id || '';
    const deptName = event?.department_name || '';

    this.filterDebounceTimer = setTimeout(() => {
      // set form + local state
      if (deptId) {
        this.departmentID = deptId;
      } else {
        this.departmentID = '';
        this.filterForm.controls['selectedEmployee'].setValue('');
      }

      // refresh employee list for this department
      // (this will also call fetchReportData() once it finishes)
      this.fetchEmployees(deptName, deptId);

      // remove this extra fetch to avoid double-calling the API
      // this.fetchReportData();  <-- DELETE
      this.clearFilter();
    }, 300);
  }


  // Optimized stats calculation
  calculateAttendanceStats(): void {
    console.log('=== CALCULATING OPTIMIZED STATS ===');

    if (!this.attendanceList.length) {
      this.resetStats();
      return;
    }

    let presentCount = 0;
    let absentCount = 0;
    let halfDayCount = 0;

    for (let i = 0; i < this.attendanceList.length; i++) {
      const record = this.attendanceList[i];

      let effectiveStatus = '';

      if (record.employee_status &&
        record.employee_status !== 'null' &&
        record.employee_status.trim() !== '' &&
        record.employee_status !== null) {
        effectiveStatus = record.employee_status.toLowerCase();
      } else {
        effectiveStatus = record.attendance_status || '';
      }

      const normalizedStatus = effectiveStatus.toLowerCase();

      if (this.isPresentStatus(normalizedStatus)) presentCount++;
      if (this.isAbsentStatus(normalizedStatus)) absentCount++;

      // Count half day variations
      if (normalizedStatus.includes('half day')) halfDayCount++;
    }

    const totalEmployees = this.attendanceList.length;
    this.fullDayCount = presentCount;
    this.absentCount = absentCount;
    this.halfDayCount = halfDayCount;

    this.attendancePercentage = totalEmployees > 0 ? Math.round((presentCount / totalEmployees) * 100) : 0;
    this.absentPercentage = totalEmployees > 0 ? Math.round((absentCount / totalEmployees) * 100) : 0;
    this.halfDayPercentage = totalEmployees > 0 ? Math.round((halfDayCount / totalEmployees) * 100) : 0;

    // Calculate half-day breakdown (ADD THIS LINE)
    this.calculateHalfDayBreakdown();

    console.log('Optimized Stats - Present:', presentCount, 'Absent:', absentCount,
      'Half Day:', halfDayCount, 'Total:', totalEmployees);

    this.calculateFilteredStats();
  }

  // ADD THESE NEW METHODS (after calculateAttendanceStats method)

  // Calculate filtered stats based on dropdown selection
  calculateFilteredStats(): void {
    console.log('=== CALCULATING FILTERED STATS ===', 'Selected filter:', this.selectedFilter);

    if (!this.attendanceList.length) {
      this.filteredCount = 0;
      this.filteredPercentage = 0;
      return;
    }

    let count = 0;

    for (let i = 0; i < this.attendanceList.length; i++) {
      const record = this.attendanceList[i];

      // Check ALL possible fields for status
      let effectiveStatus = '';

      // 1. Check employee_status first
      if (record.employee_status &&
        record.employee_status !== 'null' &&
        record.employee_status.trim() !== '' &&
        record.employee_status !== null) {
        effectiveStatus = record.employee_status.toLowerCase();
      }
      // 2. Check leave_type
      else if (record.leave_type &&
        record.leave_type !== 'null' &&
        record.leave_type.trim() !== '' &&
        record.leave_type !== null) {
        effectiveStatus = record.leave_type.toLowerCase();
      }
      // 3. Check attendance_status
      else if (record.attendance_status) {
        effectiveStatus = record.attendance_status.toLowerCase();
      }

      // Check based on selected filter
      switch (this.selectedFilter) {
        case 'absent':
          if (effectiveStatus === 'absent') count++;
          break;
        case 'local_leave':
          if (effectiveStatus.includes('local leave')) count++;
          break;
        case 'vacation':
          if (effectiveStatus.includes('vacation')) count++;
          break;
        case 'sick_leave':
          if (effectiveStatus.includes('sick leave')) count++;
          break;
        case 'half_day':
          // Count all half day variations
          if (effectiveStatus.includes('half day')) count++;
          break;
        case 'half_day_late_in':
          // Count only half day - late in
          if (effectiveStatus.includes('half day - late in') ||
            effectiveStatus.includes('half day late in')) {
            count++;
          }
          break;
        case 'half_day_early_out':
          // Count only half day - early out
          if (effectiveStatus.includes('half day - early out') ||
            effectiveStatus.includes('half day early out')) {
            count++;
          }
          break;
      }
    }

    const totalEmployees = this.attendanceList.length;
    this.filteredCount = count;
    this.filteredPercentage = totalEmployees > 0 ? Math.round((count / totalEmployees) * 100) : 0;

    console.log('Filtered Stats - Type:', this.selectedFilter, 'Count:', count,
      'Total Employees:', totalEmployees, 'Percentage:', this.filteredPercentage);
  }

  // Handle filter dropdown change
  onFilterChange(filterValue: string): void {
    this.selectedFilter = filterValue;
    this.calculateFilteredStats();
    this.filterEmployeesByStatus(filterValue);
  }

  // Filter employees table by selected status
  filterEmployeesByStatus(filterValue: string): void {
    console.log('🔍 Filtering employees by status:', filterValue);

    if (this.groupedEmployee && this.groupedEmployee.length > 0) {
      this.filteredGroupedEmployee = this.groupedEmployee.filter((employee: any) => {
        const status = this.getDisplayAttendanceStatus(employee).toLowerCase();

        switch (filterValue) {
          case 'absent':
            return status === 'absent';
          case 'local_leave':
            return status.includes('local leave');
          case 'vacation':
            return status.includes('vacation');
          case 'sick_leave':
            return status.includes('sick leave');
          case 'half_day':
            // Filter all half day variations
            return status.includes('half day');
          case 'half_day_late_in':
            // Filter only half day - late in
            return status.includes('half day - late in') ||
              status.includes('half day late in');
          case 'half_day_early_out':
            // Filter only half day - early out
            return status.includes('half day - early out') ||
              status.includes('half day early out');
          default:
            return false;
        }
      });

      this.displayGroupedEmployee = this.filteredGroupedEmployee;
      this.showOnlyAbsent = true;
      this.currentPage = 1;
      this.updatePagination();

      console.log('📊 Filtered employees:', this.filteredGroupedEmployee.length);
    }
  }

  // Get current filter label
  // Get current filter label
  getFilterLabel(): string {
    // Check if half-day filter is active
    if (this.selectedHalfDayType !== 'all_half_day' && this.showOnlyAbsent) {
      const halfDayOption = this.halfDayTypeOptions.find(opt => opt.value === this.selectedHalfDayType);
      return halfDayOption ? halfDayOption.label : 'Half Days';
    }

    const filter = this.attendanceFilterOptions.find(opt => opt.value === this.selectedFilter);
    return filter ? filter.label : 'Absent';
  }

  // Get filter badge color
  getFilterColorClass(): string {
    const filter = this.attendanceFilterOptions.find(opt => opt.value === this.selectedFilter);
    return filter ? `bg-${filter.color}` : 'bg-danger';
  }

  // Cached first record method
  getFirstAttendanceRecord(employee: any): any {
    if (!employee || !employee.employee_id) return {};

    const cacheKey = employee.employee_id;

    if (this.firstRecordCache.has(cacheKey)) {
      return this.firstRecordCache.get(cacheKey);
    }

    const firstRecord = employee.attendance && employee.attendance.length > 0
      ? employee.attendance[0]
      : {};

    this.firstRecordCache.set(cacheKey, firstRecord);
    return firstRecord;
  }

  // Pagination methods
  updatePagination(): void {
    if (!this.displayGroupedEmployee) {
      this.paginatedEmployees = [];
      this.totalItems = 0;
      return;
    }

    this.totalItems = this.displayGroupedEmployee.length;
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;

    this.paginatedEmployees = this.displayGroupedEmployee.slice(startIndex, endIndex);
  }

  onPageChange(page: number): void {
    this.currentPage = page;
    this.updatePagination();
  }

  // ========== EXISTING METHODS (OPTIMIZED) ==========

  // Helper method to get today's date in YYYY-MM-DD format
  getTodayDate(): string {
    return new Date().toISOString().split('T')[0];
  }

  // Method to format date for details page
  getFormattedDateForDetails(): string {
    if (this.formattedDate) {
      const dateObj = new Date(this.formattedDate);
      const year = dateObj.getFullYear();
      const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
      return `${year}-${month}`;
    } else {
      const currentDate = new Date();
      return `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}`;
    }
  }

  getMonthFromDate(dateString: string): string {
    if (!dateString) {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
      return `${year}-${month}`;
    }

    const dateObj = new Date(dateString);
    const year = dateObj.getFullYear();
    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    return `${year}-${month}`;
  }

  // Method to calculate estimated export time
  calculateExportTime(): string {
    const fromDate = this.exportForm.get('fromDate')?.value;
    const toDate = this.exportForm.get('toDate')?.value;

    if (!fromDate || !toDate) {
      return '';
    }

    const start = new Date(fromDate);
    const end = new Date(toDate);

    const monthsDiff = (end.getFullYear() - start.getFullYear()) * 12 +
      (end.getMonth() - start.getMonth());

    const baseTimePerMonth = 16;
    const estimatedSeconds = Math.max(1, monthsDiff + 1) * baseTimePerMonth;

    if (estimatedSeconds < 60) {
      return `${estimatedSeconds} seconds`;
    } else {
      const minutes = Math.ceil(estimatedSeconds / 60);
      return `${minutes} minute${minutes > 1 ? 's' : ''}`;
    }
  }

  // Method to get month count for the selected range
  getMonthCount(): number {
    const fromDate = this.exportForm.get('fromDate')?.value;
    const toDate = this.exportForm.get('toDate')?.value;

    if (!fromDate || !toDate) {
      return 0;
    }

    const start = new Date(fromDate);
    const end = new Date(toDate);

    return Math.max(1, (end.getFullYear() - start.getFullYear()) * 12 +
      (end.getMonth() - start.getMonth()) + 1);
  }

  // FIXED: Filter absent employees
  filterAbsentEmployees(): void {
    console.log('🔍 Filtering absent employees');

    if (this.groupedEmployee && this.groupedEmployee.length > 0) {
      this.filteredGroupedEmployee = this.groupedEmployee.filter((employee: any) => {
        const firstRecord = this.getFirstAttendanceRecord(employee);
        const status = this.getDisplayAttendanceStatus(employee); // Use the same display logic
        return this.isAbsentStatus(status);
      });

      this.displayGroupedEmployee = this.filteredGroupedEmployee;
      this.showOnlyAbsent = true;
      this.currentPage = 1;
      this.updatePagination();

      console.log('📊 Absent employees filtered:', this.filteredGroupedEmployee.length);
    } else {
      console.log('❌ No grouped employee data available for filtering');
    }
  }

  // Clear filter and show all employees
  // REPLACE the existing clearFilter() method with this:
  clearFilter(): void {
    this.displayGroupedEmployee = this.groupedEmployee;
    this.showOnlyAbsent = false;
    this.filteredGroupedEmployee = null;
    this.selectedFilter = 'absent'; // Reset to default
    this.selectedHalfDayType = 'all_half_day'; // Reset half-day type (ADD THIS)
    this.calculateFilteredStats(); // Recalculate
    this.currentPage = 1;
    this.updatePagination();
  }

  // FIXED: Open export modal with proper modal management
  openExportModal(): void {
    if (this.isModalOpen) {
      return;
    }

    // Set default dates (last 7 days)
    const toDate = new Date();
    const fromDate = new Date();
    fromDate.setDate(toDate.getDate() - 7);

    this.exportForm.patchValue({
      fromDate: fromDate.toISOString().split('T')[0],
      toDate: toDate.toISOString().split('T')[0]
    });

    this.isModalOpen = true;

    setTimeout(() => {
      const modalElement = this.exportModal.nativeElement;
      this.exportModalInstance = new bootstrap.Modal(modalElement, {
        backdrop: true,
        keyboard: true,
        focus: true
      });

      this.exportModalInstance.show();

      modalElement.addEventListener('hidden.bs.modal', () => {
        this.onModalHidden();
      });
    }, 100);
  }

  // FIXED: Close export modal properly
  closeExportModal(): void {
    if (this.exportModalInstance) {
      this.exportModalInstance.hide();
    }
    this.isModalOpen = false;
  }

  // Handle modal hidden event
  onModalHidden(): void {
    this.isModalOpen = false;
    this.exportModalInstance = null;
  }

  // Download export data
  // FIXED: Frontend-only export without API call
  downloadExport(): void {
    console.log('💾 Starting Excel download via API');

    if (this.exportForm.valid) {
      this.isExporting = true;

      const fromDate = this.exportForm.get('fromDate')?.value;
      const toDate = this.exportForm.get('toDate')?.value;
      const adminId = this.getAdminId();

      // Use the baseUrl from environment configuration instead of hardcoded URL
      const apiUrl = `${environment.baseUrl}attendance-view/download-excel-report?from_date=${fromDate}&to_date=${toDate}&admin_id=${adminId}`;

      console.log('🔗 API URL:', apiUrl);

      // Use HttpClient to leverage the interceptor
      this.http.get(apiUrl, {
        responseType: 'blob' as 'json'
      }).subscribe({
        next: (response: any) => {
          const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          console.log('✅ File downloaded successfully, size:', blob.size);

          // Create and trigger download
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `attendance_report_${fromDate}_to_${toDate}.xlsx`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          // Clean up
          window.URL.revokeObjectURL(url);
          this.isExporting = false;
          this.closeExportModal();
        },
        error: (err: any) => {
          console.error('❌ Download failed:', err);
          this.isExporting = false;

          if (err.status === 401) {
            alert('Session expired. Please login again.');
          } else if (err.status === 0) {
            alert('Network error. Please check if the server is running and CORS is configured.');
          } else {
            alert('Download failed. Please try again.');
          }
        }
      });
    } else {
      alert('Please select both From Date and To Date');
    }
  }

  // Method to display data source with formatted text
  getDisplayDataSource(employee: any): string {
    const attendanceRecord = this.getFirstAttendanceRecord(employee);
    const dataSource = attendanceRecord.data_source;

    if (!dataSource) {
      return 'Not Set';
    }

    if (dataSource === 'office') {
      return 'Office';
    } else if (dataSource === 'mobile') {
      return 'Mobile';
    } else if (dataSource === 'manual') {
      return 'Manual';
    } else {
      return dataSource.charAt(0).toUpperCase() + dataSource.slice(1);
    }
  }

  // Method to get CSS class for data source
  getDataSourceClass(employee: any): string {
    const attendanceRecord = this.getFirstAttendanceRecord(employee);
    const dataSource = (attendanceRecord.data_source || '').toLowerCase();

    if (dataSource === 'office') {
      return 'badge bg-primary';
    } else if (dataSource === 'mobile') {
      return 'badge bg-success';
    } else if (dataSource === 'manual') {
      return 'badge bg-warning text-dark';
    } else {
      return 'badge bg-secondary';
    }
  }

  // FIXED: Method to display attendance status (show employee_status if not null, then leave_type, then attendance_status)
  getDisplayAttendanceStatus(employee: any): string {
    const attendanceRecord = this.getFirstAttendanceRecord(employee);

    console.log('Checking attendance record for:', employee.employee_name, 'record:', attendanceRecord);

    // 1. Check employee_status first (working or in break)
    if (attendanceRecord.employee_status &&
      attendanceRecord.employee_status !== 'null' &&
      attendanceRecord.employee_status.trim() !== '' &&
      attendanceRecord.employee_status !== null) {
      console.log('Using employee_status:', attendanceRecord.employee_status);
      return attendanceRecord.employee_status;
    }

    // 2. If employee_status is null, check leave_type
    if (attendanceRecord.leave_type &&
      attendanceRecord.leave_type !== 'null' &&
      attendanceRecord.leave_type.trim() !== '' &&
      attendanceRecord.leave_type !== null) {
      console.log('Using leave_type:', attendanceRecord.leave_type);
      return attendanceRecord.leave_type;
    }

    // 3. Otherwise show attendance status
    const status = attendanceRecord.attendance_status;
    const result = status && status !== 'null' ? status : 'Not Set';
    console.log('Using attendance_status:', result);
    return result;
  }

  // Method to get CSS class for attendance status with consistent colors
  getAttendanceStatusClass(employee: any): string {
    const status = this.getDisplayAttendanceStatus(employee).toLowerCase();

    switch (status) {
      case 'present':
      case 'full day':
      case 'working': // Add working status
        return 'badge bg-success'; // Green for Present/Working
      case 'half day':
      case 'half day - late in':
      case 'half day - early out':
        return 'badge bg-warning'; // Orange for Half Day
      case 'holiday':
        return 'badge bg-warning text-dark'; // Yellow for Holiday
      case 'absent':
        return 'badge bg-danger'; // Red for Absent
      case 'in break': // Add in break status
        return 'badge bg-info text-dark'; // Blue for In Break
      case 'sick leave':
      case 'local leave':
      case 'vacation':
      case 'annual leave':
      case 'casual leave':
      case 'emergency leave':
      case 'maternity leave':
      case 'paternity leave':
      case 'compensatory leave':
        return 'badge bg-primary'; // Blue for all leave types
      default:
        return 'badge bg-light text-dark'; // Light gray for unknown
    }
  }

  // Method to calculate half-day breakdown
  calculateHalfDayBreakdown(): void {
    console.log('=== CALCULATING HALF DAY BREAKDOWN ===');

    this.halfDayLateInCount = 0;
    this.halfDayEarlyOutCount = 0;
    this.halfDayGeneralCount = 0;

    if (!this.attendanceList.length) return;

    for (let i = 0; i < this.attendanceList.length; i++) {
      const record = this.attendanceList[i];

      let effectiveStatus = '';

      // Check employee_status first
      if (record.employee_status &&
        record.employee_status !== 'null' &&
        record.employee_status.trim() !== '' &&
        record.employee_status !== null) {
        effectiveStatus = record.employee_status.toLowerCase();
      }
      // Check leave_type
      else if (record.leave_type &&
        record.leave_type !== 'null' &&
        record.leave_type.trim() !== '' &&
        record.leave_type !== null) {
        effectiveStatus = record.leave_type.toLowerCase();
      }
      // Check attendance_status
      else if (record.attendance_status) {
        effectiveStatus = record.attendance_status.toLowerCase();
      }

      // Count half day types
      if (effectiveStatus.includes('half day')) {
        if (effectiveStatus.includes('half day - late in') ||
          effectiveStatus.includes('half day late in')) {
          this.halfDayLateInCount++;
        } else if (effectiveStatus.includes('half day - early out') ||
          effectiveStatus.includes('half day early out')) {
          this.halfDayEarlyOutCount++;
        } else if (effectiveStatus === 'half day' ||
          effectiveStatus.includes('half day general')) {
          this.halfDayGeneralCount++;
        }
      }
    }

    console.log('Half Day Breakdown - Late In:', this.halfDayLateInCount,
      'Early Out:', this.halfDayEarlyOutCount,
      'General:', this.halfDayGeneralCount);
  }

  // Handle half-day dropdown change
  onHalfDayTypeChange(typeValue: string): void {
    this.selectedHalfDayType = typeValue;
    this.filterEmployeesByHalfDayType(typeValue);
  }

  // Filter employees by half-day type
  filterEmployeesByHalfDayType(halfDayType: string): void {
    console.log('🔍 Filtering employees by half-day type:', halfDayType);

    if (this.groupedEmployee && this.groupedEmployee.length > 0) {
      this.filteredGroupedEmployee = this.groupedEmployee.filter((employee: any) => {
        const status = this.getDisplayAttendanceStatus(employee).toLowerCase();

        if (!status.includes('half day')) return false;

        switch (halfDayType) {
          case 'all_half_day':
            return status.includes('half day');
          case 'half_day_late_in':
            return status.includes('half day - late in') ||
              status.includes('half day late in');
          case 'half_day_early_out':
            return status.includes('half day - early out') ||
              status.includes('half day early out');
          case 'half_day_general':
            return status === 'half day' ||
              status.includes('half day general');
          default:
            return status.includes('half day');
        }
      });

      this.displayGroupedEmployee = this.filteredGroupedEmployee;
      this.showOnlyAbsent = true;
      this.currentPage = 1;
      this.updatePagination();

      console.log('📊 Filtered half-day employees:', this.filteredGroupedEmployee.length);
    }
  }

  // Add a method to get the count for selected half-day type
  getHalfDayCountForType(type: string): number {
    switch (type) {
      case 'all_half_day':
        return this.halfDayCount;
      case 'half_day_late_in':
        return this.halfDayLateInCount;
      case 'half_day_early_out':
        return this.halfDayEarlyOutCount;
      case 'half_day_general':
        return this.halfDayGeneralCount;
      default:
        return this.halfDayCount;
    }
  }

  ngOnInit(): void {
    console.log('=== COMPONENT INITIALIZATION ===');

    const savedState = this.commonfn.getFilterFormState();

    if (savedState) {
      const savedDate = savedState.date || savedState.formattedDate || this.getTodayDate();
      this.formattedDate = savedDate;

      this.filterForm.patchValue({
        date: savedDate,
        selectedEmployee: savedState.selectedEmployee || '',
        selectedDepartment: savedState.selectedDepartment || '',
      });

      if (savedState.departmentID) {
        this.departmentID = savedState.departmentID;
      }
      // Restore filter selections BEFORE data loads
      if (savedState.selectedFilter) {
        this.selectedFilter = savedState.selectedFilter;
      }
      if (savedState.selectedHalfDayType) {
        this.selectedHalfDayType = savedState.selectedHalfDayType;
      }

      if (savedState.showOnlyAbsent !== undefined) {
        this.showOnlyAbsent = savedState.showOnlyAbsent;
      }

      // Clear state so it doesn't persist on hard refresh
      this.commonfn.saveFilterFormState(null);
    } else {
      this.formattedDate = this.getTodayDate();
      this.filterForm.controls['date'].setValue(this.formattedDate);
    }

    this.isFactoryManager =
      localStorage.getItem('userTypecon')?.toUpperCase() === 'FACTORY_MANAGER';

    this.fetchEmployees();
    this.fetchDepartments();

    this.routerSubscription = this.route.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.nextUrl = event.url;
      }
    });
  }


  // Data fetching methods
  // refresh employee dropdown; trigger report fetch ONCE after dropdown loads
  fetchEmployees(searchValue?: string, departmentId?: string): void {
    if (this.isFactoryManager) {
      this.filterForm.controls['selectedDepartment'].setValue('UMM AL QUWAIN FACTORY');
    }

    const deptValue = this.filterForm.controls['selectedDepartment'].value;
    const departmentFilter = typeof deptValue === 'object' && deptValue !== null
      ? deptValue.department_name
      : (deptValue || '');
    // keep the departmentID passed in (don’t overwrite it with empty/defaults)
    if (departmentId) {
      this.departmentID = departmentId;
    }
    console.log('DEPARTMENT FILTER VALUE:', departmentFilter);
    console.log('DEPARTMENT ID:', this.departmentID);
    this.apiService.ViewAllEmployeefilter(`?department=${departmentFilter}`).subscribe({
      next: (response) => {
        this.employeeDropdown = response.data || [];

        // supervisor flags (unchanged)
        const supervisor = {
          id: localStorage.getItem('headDep_id'),
          name: localStorage.getItem('headDep_name'),
        };
        if (supervisor.id && supervisor.name && supervisor.id !== 'undefined' && supervisor.name !== 'undefined') {
          this.supervisor.id = supervisor.id;
          this.supervisor.name = supervisor.name;
          this.isSupervisor = true;
        } else {
          this.supervisor.id = '';
          this.supervisor.name = '';
          this.isSupervisor = false;
        }

        // 🔹 single, final fetch – now guaranteed to include department_id (if set)
        this.fetchReportData();
      },
      error: (err) => {
        console.error('Error fetching employees:', err);
        this.employeeDropdown = [];
        // still fetch once so UI isn’t stuck
        this.fetchReportData();
      },
    });
  }


  fetchDepartments(): void {
    this.apiService.departmentDropdown().subscribe({
      next: (response) => {
        this.departmentDropdown = response.data || [];
      },
      error: (err) => {
        console.error('Error fetching departments:', err);
        this.departmentDropdown = [];
      },
    });
  }

  // UPDATED: Fetch data for specific date with proper parameter handling
  fetchReportData(): void {
    console.log('=== FETCHING REPORT DATA ===');

    this.isLoading = true;
    // Clear cache for new data
    this.firstRecordCache.clear();

    const employeeId = this.filterForm.controls['selectedEmployee'].value || '';
    const adminId = this.getAdminId();

    // Build query parameters as string
    let params = `?from_date=${this.formattedDate}&to_date=${this.formattedDate}`;

    params += `&admin_id=${adminId}`;
    console.log('FETCH REPORT - departmentID:', this.departmentID);
    if (this.departmentID) {
      params += `&department_id=${this.departmentID}`;
    }
    if (employeeId) {
      params += `&employee_id=${employeeId}`;
    }
    if (this.supervisor.id) {
      params += `&factory_department_id=${this.supervisor.id}`;
    }

    // UPDATED: Using the new endpoint
    this.methodService
      .get(endPoints.employeeAttendanceByDate + params)
      .subscribe({
        next: (response) => {
          this.isLoading = false;

          if (response && response.data) {
            this.attendanceList = response.data;
          } else if (Array.isArray(response)) {
            this.attendanceList = response;
          } else if (response && response.attendance) {
            this.attendanceList = response.attendance;
          } else {
            this.attendanceList = [];
          }

// Use summary from API directly
if (response && response.summary) {
  const summary = response.summary;
  const total = summary.total_employees || 0;

  this.fullDayCount = summary.present || 0;
  this.absentCount = summary.absent || 0;

  this.attendancePercentage = total > 0 ? Math.round((this.fullDayCount / total) * 100) : 0;
  this.absentPercentage = total > 0 ? Math.round((this.absentCount / total) * 100) : 0;
} else {
  this.calculateAttendanceStats(); // fallback if summary missing
}

this.calculateFilteredStats();
          this.groupedEmployee = this.commonfn.groupAttendanceByEmployee(
            this.attendanceList
          );

          this.displayGroupedEmployee = this.groupedEmployee;
          this.showOnlyAbsent = false;
          this.currentPage = 1;

          // Re-apply active filter after data is ready
          this.reApplyActiveFilter();

          this.updatePagination();
        },
        error: (err) => {
          this.isLoading = false;
          console.error('=== ATTENDANCE API ERROR ===');
          console.error('Error fetching attendance:', err);

          this.attendanceList = [];
          this.groupedEmployee = [];
          this.displayGroupedEmployee = [];
          this.paginatedEmployees = [];
          this.resetStats();
        }
      });
  }


  private reApplyActiveFilter(): void {
    if (this.selectedHalfDayType && this.selectedHalfDayType !== 'all_half_day') {
      this.filterEmployeesByStatus('half_day');
      setTimeout(() => {
        this.filterEmployeesByHalfDayType(this.selectedHalfDayType);
      }, 0);
      return;
    }

    if (this.selectedFilter && this.selectedFilter !== 'absent') {
      this.filterEmployeesByStatus(this.selectedFilter);
    }
  }
  private resetStats(): void {
    this.attendancePercentage = 0;
    this.absentPercentage = 0;
    this.fullDayCount = 0;
    this.absentCount = 0;
    this.halfDayCount = 0;
    this.halfDayPercentage = 0;
    this.halfDayLateInCount = 0;
    this.halfDayEarlyOutCount = 0;
    this.halfDayGeneralCount = 0;
  }

  goToShiftAssignment(): void {
    this.route.navigate(['/admin/department-list']);
  }

  ngOnDestroy() {
    if (this.filterDebounceTimer) {
      clearTimeout(this.filterDebounceTimer);
    }
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    if (this.exportModalInstance) {
      this.exportModalInstance.hide();
      this.exportModalInstance = null;
    }

    console.log('Navigating to:', this.nextUrl);

    if (this.nextUrl?.includes('/admin/employee-attendance-beta-details')) {
      const stateToSave = {
        ...this.filterForm.value,
        departmentID: this.departmentID,
        date: this.filterForm.controls['date'].value,
        formattedDate: this.formattedDate,
        selectedFilter: this.selectedFilter,
        selectedHalfDayType: this.selectedHalfDayType,
        showOnlyAbsent: this.showOnlyAbsent
      };
      this.commonfn.saveFilterFormState(stateToSave);
    } else {
      this.commonfn.saveFilterFormState(null);
    }
  }

}